export const backendMixin = {
  methods: {
    handleError (error, route) {
      if (error.response.status === 404) {
        this.$router.push({ name: 'notfound', params: { '0': route.path } })
      }
    }
  }
}
